module.exports = __webpack_public_path__ + "static/media/golfer-7-a.f96e8712.png";